import { Link } from 'gatsby'
import React, { useContext, useEffect, useState } from 'react'
// import { AnimatePresence } from 'framer-motion';

import NewsletterSubscribe from '~/components/NewsletterSubscribe';
import TransContext from '~/contexts/TransContext';
import SocialIconAlt from '~/components/SocialIconAlt';
import MobileNavItem from '~/components/MobileNavItem';
import headerNavs from '~/data/header-navs';

import { motion } from 'framer-motion';


export default function MobileNav({className}) {
  const trans = useContext(TransContext);
  const [active, setActive] = useState('');

  const localeHeader = (trans?.lang?.length > 0) ? headerNavs[trans?.lang] : headerNavs['default'];

  return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ type: 'tween', duration: 0.3 }}
      >
      <div className={`fixed md:hidden overflow-auto pb-24 top-24 right-0 bottom-0 left-0 bg-white text-black mobile-nav ${className}`}>
        <div className="container">
          <nav className={`font-medium font-heading mt-8`}>
            {localeHeader.map((item, i) => (
              <MobileNavItem key={`mobilenav${i}`} item={item} active={active} setActive={setActive}/>
            ))}
          </nav>
          <div className="flex flex-col my-8 font-semibold text-center font-heading text-14px">
            <div className="mb-2">
              <Link
                to={trans?.content?.headerActions[1]?.button?.cached_url}
                className={`c-btn c-btn--short c-btn--primary transition-colors duration-200 ease-in-out justify-center`}>
                {trans?.content?.headerActions[1]?.title}
              </Link>
            </div>
            <a href={trans?.content?.headerActions[0]?.button?.cached_url} target="_blank" className="flex items-center justify-center c-btn c-btn--outline">
              {trans?.content?.headerActions[0]?.title}
            </a>
          </div>
          <div className="mb-4">
            <NewsletterSubscribe hideIcon className="text-center"  formClass="mt-4 border-white bg-light-grey h-auto mx-auto" inputClass="py-4 p-6 h-auto"/>
          </div>
          <div className="flex justify-center">
            {[
              { type: 'facebook' },
              { type: 'youtube' },
              { type: 'linkedin' },
              { type: 'instagram' },
            ].map((item, i) => (
              <div key={`${i}`}>
                <SocialIconAlt type={item.type} />
              </div>
            ))}
          </div>
          <div className="mt-3 font-semibold text-center text-14px">© {new Date().getFullYear()}. BOOM. {trans?.content?.rightsReserved}</div>
        </div>
      </div>
    </motion.div>
  )
}
